export enum PomodoroStatus {
  WORK,
  SHORT_BREAK,
  LONG_BREAK
}
